module.exports = __webpack_public_path__ + "img/icon-s-cross.9c6407c5.png";